import { useEffect, useRef, useState } from "react";

export const useReveal = (threshold = 0.15) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        setInView(true);
                        obs.unobserve(e.target);
                    }
                });
            },
            { threshold }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, [threshold]);

    return { ref, className: `reveal ${inView ? "in-view" : ""}` };
};
